/** Central blog configuration — edit order, add posts here. */

export const blogPosts = [
  {
    id: "best-client-portal-software-buyers-guide",
    slug: "best-client-portal-software-buyers-guide",
    title: "Best Client Portal Software: How to Choose One That Fits Your Firm",
    description: "What separates good client portal software from a shared folder: the features that matter, the questions to ask vendors, and options for small firms.",
    order: 29,
    image: "/assets/best-client-portal-software-buyers-guide.png",
    imageAlt: "Illustration for Best Client Portal Software: How to Choose One That Fits Your Firm",
    contentPath: "/content/best-client-portal-software-buyers-guide.html",
    category: "Document Security",
    featured: true,
    layout: "default",
    seoTitle: "Best Client Portal Software: A Buyer's Guide for 2026",
    seoDescription: "What separates good client portal software from a shared folder: the features that matter, the questions to ask vendors, and options for small firms.",
    canonicalPath: "/blog/best-client-portal-software-buyers-guide",
  },
  {
    id: "secure-file-sharing-for-law-firms",
    slug: "secure-file-sharing-for-law-firms",
    title: "Secure File Sharing for Law Firms: What \"Reasonable Efforts\" Looks Like in Practice",
    description: "How law firms can share client files securely: what the ABA confidentiality rules expect, where email falls short, and what to look for in a portal.",
    order: 28,
    image: "/assets/secure-file-sharing-for-law-firms.png",
    imageAlt: "Illustration for Secure File Sharing for Law Firms: What \"Reasonable Efforts\" Looks Like in Practice",
    contentPath: "/content/secure-file-sharing-for-law-firms.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "Secure File Sharing for Law Firms: A Practical Guide",
    seoDescription: "How law firms can share client files securely: what the ABA confidentiality rules expect, where email falls short, and what to look for in a portal.",
    canonicalPath: "/blog/secure-file-sharing-for-law-firms",
  },
  {
    id: "client-portal-for-accountants",
    slug: "client-portal-for-accountants",
    title: "Client Portals for Accountants: How to Choose a Secure One Before Tax Season",
    description: "What a secure client portal for accountants should do: tracked document requests, encryption, named access, and how it supports your FTC Safeguards duties.",
    order: 27,
    image: "/assets/client-portal-for-accountants.png",
    imageAlt: "Illustration for Client Portals for Accountants: How to Choose a Secure One Before Tax Season",
    contentPath: "/content/client-portal-for-accountants.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "Client Portal for Accountants: What to Look For in 2026",
    seoDescription: "What a secure client portal for accountants should do: tracked document requests, encryption, named access, and how it supports your FTC Safeguards duties.",
    canonicalPath: "/blog/client-portal-for-accountants",
  },
  {
    id: "what-happens-to-your-documents-when-life-changes",
    slug: "what-happens-to-your-documents-when-life-changes",
    title: "What happens to your documents when life changes",
    description: "Life rarely gives us time to prepare. A medical emergency. A new home purchase. A tax deadline. Helping aging parents manage their finances. These moments happen quickly, and...",
    order: 26,
    image: "/assets/what-happens-to-your-documents-when-life-changes.png",
    imageAlt: "Illustration for What happens to your documents when life changes",
    contentPath: "/content/what-happens-to-your-documents-when-life-changes.html",
    category: "Document Security",
    featured: true,
    layout: "default",
    seoTitle: "What happens to your documents when life changes | SafeVault Blogs",
    seoDescription: "Life rarely gives us time to prepare. A medical emergency. A new home purchase. A tax deadline. Helping aging parents manage their finances. These moments happen quickly, and...",
    canonicalPath: "/blog/what-happens-to-your-documents-when-life-changes",
  },
  {
    id: "why-cpa-teams-struggle-during-tax-season",
    slug: "why-cpa-teams-struggle-during-tax-season",
    title: "Why CPA Teams Struggle During Tax Season",
    description: "Tax season is expected to be busy. But should it feel chaotic? For many CPA teams, the biggest challenge is not the number of tax returns. It is everything happening around...",
    order: 25,
    image: "/assets/why-cpa-teams-struggle-during-tax-season.png",
    imageAlt: "Illustration for Why CPA Teams Struggle During Tax Season",
    contentPath: "/content/why-cpa-teams-struggle-during-tax-season.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "Why CPA Teams Struggle During Tax Season | SafeVault Blogs",
    seoDescription: "Tax season is expected to be busy. But should it feel chaotic? For many CPA teams, the biggest challenge is not the number of tax returns. It is everything happening around...",
    canonicalPath: "/blog/why-cpa-teams-struggle-during-tax-season",
  },
  {
    id: "how-safevault-helps-families-prepare-for-taxes-loans-and-life-events",
    slug: "how-safevault-helps-families-prepare-for-taxes-loans-and-life-events",
    title: "How SafeVault Helps Families Prepare for Taxes, Loans, and Life Events",
    description: "Every family has that one drawer. It's filled with tax returns from three years ago, insurance policies, birth certificates, home documents, medical records, and a handful of...",
    order: 24,
    image: "/assets/how-safevault-helps-families-prepare-for-taxes-loans-and-life-events.png",
    imageAlt: "Illustration for How SafeVault Helps Families Prepare for Taxes, Loans, and Life Events",
    contentPath: "/content/how-safevault-helps-families-prepare-for-taxes-loans-and-life-events.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "How SafeVault Helps Families Prepare for Taxes, Loans, and Life Events | SafeVault Blogs",
    seoDescription: "Every family has that one drawer. It's filled with tax returns from three years ago, insurance policies, birth certificates, home documents, medical records, and a handful of...",
    canonicalPath: "/blog/how-safevault-helps-families-prepare-for-taxes-loans-and-life-events",
  },
  {
    id: "a-calm-secure-place-for-important-files",
    slug: "a-calm-secure-place-for-important-files",
    title: "A Calm, Secure Place for Important Files",
    description: "Important documents turn up missing at the worst moments. Which family documents to keep together, how to store them safely and who should have access.",
    order: 23,
    image: "/assets/a-calm-secure-place-for-important-files.png",
    imageAlt: "Illustration for A Calm, Secure Place for Important Files",
    contentPath: "/content/a-calm-secure-place-for-important-files.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "A Calm, Secure Place for Your Important Files",
    seoDescription: "Important documents turn up missing at the worst moments. Which family documents to keep together, how to store them safely and who should have access.",
    canonicalPath: "/blog/a-calm-secure-place-for-important-files",
  },
  {
    id: "where-is-your-last-w-2-right-now",
    slug: "where-is-your-last-w-2-right-now",
    title: "Where Is Your Last W-2 Right Now?",
    description: "You probably know exactly where your phone is. You know where your car keys are or at least where they should be. But here's a more important question: Where is your last W-2...",
    order: 22,
    image: "/assets/where-is-your-last-w-2-right-now.png",
    imageAlt: "Illustration for Where Is Your Last W-2 Right Now?",
    contentPath: "/content/where-is-your-last-w-2-right-now.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "Where Is Your Last W-2 Right Now? | SafeVault Blogs",
    seoDescription: "You probably know exactly where your phone is. You know where your car keys are or at least where they should be. But here's a more important question: Where is your last W-2...",
    canonicalPath: "/blog/where-is-your-last-w-2-right-now",
  },
  {
    id: "ai-in-tax-preparation-replacing-data-entry-not-tax-professionals",
    slug: "ai-in-tax-preparation-replacing-data-entry-not-tax-professionals",
    title: "AI in Tax Preparation: Replacing Data Entry, Not Tax Professionals",
    description: "AI in tax preparation reads and sorts documents; it does not replace judgment. What it automates, where it fails, and what to ask before you use it.",
    order: 21,
    image: "/assets/ai-in-tax-preparation-replacing-data-entry-not-tax-professionals.png",
    imageAlt: "Illustration for AI in Tax Preparation Replacing Data Entry Not Tax Professionals",
    contentPath: "/content/ai-in-tax-preparation-replacing-data-entry-not-tax-professionals.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "AI in Tax Preparation: What It Does and Where It Stops",
    seoDescription: "AI in tax preparation reads and sorts documents; it does not replace judgment. What it automates, where it fails, and what to ask before you use it.",
    canonicalPath: "/blog/ai-in-tax-preparation-replacing-data-entry-not-tax-professionals",
  },
  {
    id: "the-real-roi-of-tax-workflow-automation",
    slug: "the-real-roi-of-tax-workflow-automation",
    title: "The Real ROI of Tax Workflow Automation",
    description: "The return on tax workflow automation is recovered hours, not features. A simple way to measure it across intake, follow-up, sorting and review.",
    order: 20,
    image: "/assets/the-real-roi-of-tax-workflow-automation.png",
    imageAlt: "Illustration for The Real ROI of Tax Workflow Automation",
    contentPath: "/content/the-real-roi-of-tax-workflow-automation.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "The Real ROI of Tax Workflow Automation: How to Measure It",
    seoDescription: "The return on tax workflow automation is recovered hours, not features. A simple way to measure it across intake, follow-up, sorting and review.",
    canonicalPath: "/blog/the-real-roi-of-tax-workflow-automation",
  },
  {
    id: "the-client-experience-gap-in-modern-tax-firms",
    slug: "the-client-experience-gap-in-modern-tax-firms",
    title: "The Client Experience Gap in Modern Tax Firms",
    description: "Clients compare your tax firm to the apps they use every day. Where the client experience breaks down, and six fixes that need no extra headcount.",
    order: 19,
    image: "/assets/the-client-experience-gap-in-modern-tax-firms.png",
    imageAlt: "Illustration for The Client Experience Gap in Modern Tax Firms",
    contentPath: "/content/the-client-experience-gap-in-modern-tax-firms.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "The Client Experience Gap in Tax Firms and How to Close It",
    seoDescription: "Clients compare your tax firm to the apps they use every day. Where the client experience breaks down, and six fixes that need no extra headcount.",
    canonicalPath: "/blog/the-client-experience-gap-in-modern-tax-firms",
  },
  {
    id: "data-privacy-regulations-every-organization-should-know",
    slug: "data-privacy-regulations-every-organization-should-know",
    title: "Data Privacy Regulations Every Financial and Tax Firm Should Know",
    description: "A plain-language guide to the US data privacy rules that financial, mortgage and tax firms are held to: GLBA, the FTC Safeguards Rule, state laws and more.",
    order: 18,
    image: "/assets/data-privacy-regulations-every-organization-should-know.png",
    imageAlt: "Illustration for Data Privacy Regulations Every Organization Should Know",
    contentPath: "/content/data-privacy-regulations-every-organization-should-know.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "Data Privacy Regulations for Financial and Tax Firms",
    seoDescription: "A plain-language guide to the US data privacy rules that financial, mortgage and tax firms are held to: GLBA, the FTC Safeguards Rule, state laws and more.",
    canonicalPath: "/blog/data-privacy-regulations-every-organization-should-know",
  },
  {
    id: "every-fintech-startup-has-this-document-problem-almost-none-of-them-have-fixed-it",
    slug: "every-fintech-startup-has-this-document-problem-almost-none-of-them-have-fixed-it",
    title: "Every Fintech Startup Has This Document Problem. Almost None Have Fixed It.",
    description: "Fintech and lending teams collect documents once and forget that they expire. Why expired documents stall files, and a simple way to track them.",
    order: 14,
    image: "/assets/every-fintech-startup-has-this-document-problem-almost-none-of-them-have-fixed-it.png",
    imageAlt: "Illustration for Every Fintech Startup Has This Document Problem. Almost None of Them Have Fixed It.",
    contentPath: "/content/every-fintech-startup-has-this-document-problem-almost-none-of-them-have-fixed-it.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "The Document Expiry Problem in Fintech and Lending",
    seoDescription: "Fintech and lending teams collect documents once and forget that they expire. Why expired documents stall files, and a simple way to track them.",
    canonicalPath: "/blog/every-fintech-startup-has-this-document-problem-almost-none-of-them-have-fixed-it",
  },
  {
    id: "why-manual-data-entry-is-the-biggest-bottleneck-in-modern-workplaces",
    slug: "why-manual-data-entry-is-the-biggest-bottleneck-in-modern-workplaces",
    title: "Why Manual Data Entry Is the Biggest Bottleneck in Modern Workplaces",
    description: "Do you guys also feel that your team is working hard enough every day, but the result is not balancing the efforts you are making? Trust us when we say this, but you are not...",
    order: 13,
    image: "/assets/why-manual-data-entry-is-the-biggest-bottleneck-in-modern-workplaces.png",
    imageAlt: "Illustration for Why Manual Data Entry Is the Biggest Bottleneck in Modern Workplaces",
    contentPath: "/content/why-manual-data-entry-is-the-biggest-bottleneck-in-modern-workplaces.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "Why Manual Data Entry Is the Biggest Bottleneck in Modern Workplaces | SafeVault Blogs",
    seoDescription: "Do you guys also feel that your team is working hard enough every day, but the result is not balancing the efforts you are making? Trust us when we say this, but you are not...",
    canonicalPath: "/blog/why-manual-data-entry-is-the-biggest-bottleneck-in-modern-workplaces",
  },
  {
    id: "global-trends-shaping-the-document-security-market-in-2026",
    slug: "global-trends-shaping-the-document-security-market-in-2026",
    title: "Document Security Trends Shaping 2026",
    description: "Six document security trends for 2026, from AI that reads your files to clients asking for proof. What each one means for a small firm and what to do.",
    order: 12,
    image: "/assets/global-trends-shaping-the-document-security-market-in-2026.png",
    imageAlt: "Illustration for Global Trends Shaping the Document Security Market in 2026",
    contentPath: "/content/global-trends-shaping-the-document-security-market-in-2026.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "Document Security Trends in 2026: What Is Changing",
    seoDescription: "Six document security trends for 2026, from AI that reads your files to clients asking for proof. What each one means for a small firm and what to do.",
    canonicalPath: "/blog/global-trends-shaping-the-document-security-market-in-2026",
  },
  {
    id: "the-hidden-cost-of-just-send-me-that-file",
    slug: "the-hidden-cost-of-just-send-me-that-file",
    title: "The Hidden Cost of “Just Send Me That File”",
    description: "Every professional has said this at some point: “Can you just send me that file?” It sounds simple. It feels harmless. But in reality, it’s one of the biggest signals of a...",
    order: 11,
    image: "/assets/the-hidden-cost-of-just-send-me-that-file.png",
    imageAlt: "Illustration for The Hidden Cost of “Just Send Me That File”",
    contentPath: "/content/the-hidden-cost-of-just-send-me-that-file.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "The Hidden Cost of “Just Send Me That File” | SafeVault Blogs",
    seoDescription: "Every professional has said this at some point: “Can you just send me that file?” It sounds simple. It feels harmless. But in reality, it’s one of the biggest signals of a...",
    canonicalPath: "/blog/the-hidden-cost-of-just-send-me-that-file",
  },
  {
    id: "the-real-value-of-a-document-is-when-it-is-ready-before-you-need-it",
    slug: "the-real-value-of-a-document-is-when-it-is-ready-before-you-need-it",
    title: "The Real Value of a Document Is When It Is Ready Before You Need It",
    description: "Most important documents are not needed every day. A tax return may sit untouched for months. An insurance record may only become important during a claim. A passport may...",
    order: 10,
    image: "/assets/the-real-value-of-a-document-is-when-it-is-ready-before-you-need-it.png",
    imageAlt: "Illustration for The Real Value of a Document Is When It Is Ready Before You Need It",
    contentPath: "/content/the-real-value-of-a-document-is-when-it-is-ready-before-you-need-it.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "The Real Value of a Document Is When It Is Ready Before You Need It | SafeVault Blogs",
    seoDescription: "Most important documents are not needed every day. A tax return may sit untouched for months. An insurance record may only become important during a claim. A passport may...",
    canonicalPath: "/blog/the-real-value-of-a-document-is-when-it-is-ready-before-you-need-it",
  },
  {
    id: "competitive-advantage-is-moving-from-speed-to-certainty",
    slug: "competitive-advantage-is-moving-from-speed-to-certainty",
    title: "Competitive Advantage Is Moving from Speed to Certainty",
    description: "For decades, companies have competed on speed. Faster onboarding, quicker approvals, streamlined processing, and shorter turnaround times became the markers of operational...",
    order: 9,
    image: "/assets/competitive-advantage-is-moving-from-speed-to-certainty.png",
    imageAlt: "Illustration for Competitive Advantage Is Moving from Speed to Certainty",
    contentPath: "/content/competitive-advantage-is-moving-from-speed-to-certainty.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "Competitive Advantage Is Moving from Speed to Certainty | SafeVault Blogs",
    seoDescription: "For decades, companies have competed on speed. Faster onboarding, quicker approvals, streamlined processing, and shorter turnaround times became the markers of operational...",
    canonicalPath: "/blog/competitive-advantage-is-moving-from-speed-to-certainty",
  },
  {
    id: "from-chaos-to-order-how-smart-digital-vaults-transform-document-organization",
    slug: "from-chaos-to-order-how-smart-digital-vaults-transform-document-organization",
    title: "From Chaos to Order: How to Organize Your Digital Documents",
    description: "A simple system for organizing digital documents at home or in a small firm: one home, a few categories, clear names and dates you will not miss.",
    order: 8,
    image: "/assets/from-chaos-to-order-how-smart-digital-vaults-transform-document-organization.png",
    imageAlt: "Illustration for From Chaos to Order: How Smart Digital Vaults Transform Document Organization",
    contentPath: "/content/from-chaos-to-order-how-smart-digital-vaults-transform-document-organization.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "How to Organize Digital Documents: A Simple System",
    seoDescription: "A simple system for organizing digital documents at home or in a small firm: one home, a few categories, clear names and dates you will not miss.",
    canonicalPath: "/blog/from-chaos-to-order-how-smart-digital-vaults-transform-document-organization",
  },
  {
    id: "why-secure-document-management-is-essential-for-every-business",
    slug: "why-secure-document-management-is-essential-for-every-business",
    title: "Why Secure Document Management Is Essential for Every Business",
    description: "Secure document management means knowing where sensitive files are, who can open them and what happened to them. A practical guide for small businesses.",
    order: 7,
    image: "/assets/why-secure-document-management-is-essential-for-every-business.png",
    imageAlt: "Illustration for Why Secure Document Management Is Essential for Every Business",
    contentPath: "/content/why-secure-document-management-is-essential-for-every-business.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "Secure Document Management: Why It Matters and What to Do",
    seoDescription: "Secure document management means knowing where sensitive files are, who can open them and what happened to them. A practical guide for small businesses.",
    canonicalPath: "/blog/why-secure-document-management-is-essential-for-every-business",
  },
  {
    id: "document-security-in-the-age-of-cyber-threats-how-digital-vaults-stay-ahead",
    slug: "document-security-in-the-age-of-cyber-threats-how-digital-vaults-stay-ahead",
    title: "Document Security in the Age of Cyber Threats",
    description: "Phishing, compromised email and overshared links cause most document exposure. What each threat looks like and the practical steps that reduce it.",
    order: 6,
    image: "/assets/document-security-in-the-age-of-cyber-threats-how-digital-vaults-stay-ahead.png",
    imageAlt: "Illustration for Document Security in the Age of Cyber Threats: How Digital Vaults Stay Ahead",
    contentPath: "/content/document-security-in-the-age-of-cyber-threats-how-digital-vaults-stay-ahead.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "Document Security: The Threats Small Firms Actually Face",
    seoDescription: "Phishing, compromised email and overshared links cause most document exposure. What each threat looks like and the practical steps that reduce it.",
    canonicalPath: "/blog/document-security-in-the-age-of-cyber-threats-how-digital-vaults-stay-ahead",
  },
  {
    id: "the-role-of-document-governance-in-modern-risk-management",
    slug: "the-role-of-document-governance-in-modern-risk-management",
    title: "The Role of Document Governance in Modern Risk Management",
    description: "For a long time, risk management focused on what was immediately visible. Financial risk, operational risk, cybersecurity threats, and regulatory exposure dominated the...",
    order: 5,
    image: "/assets/the-role-of-document-governance-in-modern-risk-management.png",
    imageAlt: "Illustration for The Role of Document Governance in Modern Risk Management",
    contentPath: "/content/the-role-of-document-governance-in-modern-risk-management.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "The Role of Document Governance in Modern Risk Management | SafeVault Blogs",
    seoDescription: "For a long time, risk management focused on what was immediately visible. Financial risk, operational risk, cybersecurity threats, and regulatory exposure dominated the...",
    canonicalPath: "/blog/the-role-of-document-governance-in-modern-risk-management",
  },
  {
    id: "why-safevault-playground-is-more-than-a-demo",
    slug: "why-safevault-playground-is-more-than-a-demo",
    title: "Why SafeVault Playground Is More Than a Demo",
    description: "When people explore a product for the first time, they are not only evaluating features. They are also evaluating comfort, trust, and effort. They are asking quiet but...",
    order: 1,
    image: "/assets/why-safevault-playground-is-more-than-a-demo.png",
    imageAlt: "Illustration for Why SafeVault Playground Is More Than a Demo",
    contentPath: "/content/why-safevault-playground-is-more-than-a-demo.html",
    category: "Document Security",
    featured: false,
    layout: "default",
    seoTitle: "Why SafeVault Playground Is More Than a Demo | SafeVault Blogs",
    seoDescription: "When people explore a product for the first time, they are not only evaluating features. They are also evaluating comfort, trust, and effort. They are asking quiet but...",
    canonicalPath: "/blog/why-safevault-playground-is-more-than-a-demo",
  },
];

/** @typedef {{
 *  id: string, slug: string, title: string, description: string, order: number,
 *  image: string, imageAlt: string, contentPath: string, category?: string,
 *  publishedDate?: string, updatedDate?: string, layout?: "left"|"right"|"default",
 *  featured?: boolean, seoTitle?: string, seoDescription?: string, canonicalPath?: string,
 *  legacyId?: number
 * }} BlogPost */

export const getSortedBlogPosts = () => [...blogPosts].sort((a, b) => b.order - a.order);

export const getBlogPostBySlug = (slug) => blogPosts.find((post) => post.slug === slug);

export const getBlogPostByLegacyId = (id) => blogPosts.find((post) => post.legacyId === id);

export const LEGACY_ID_TO_SLUG = blogPosts.reduce((acc, post) => {
  if (post.legacyId != null) acc[post.legacyId] = post.slug;
  return acc;
}, {});
